import { render, staticRenderFns } from "./ForgetPasswordPage.vue?vue&type=template&id=55536448&scoped=true&"
import script from "./ForgetPasswordPage.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55536448",
  null
  
)

export default component.exports